module.exports = __webpack_public_path__ + "static/media/orgManager.a8e35a1d.png";